<template>
   <div class="loading_content">
    <template v-if="theme == 'circle'">
      <div class="loading_circle">
        <van-loading vertical size="28px" class="loading_icon" color="#fff">加载中...</van-loading>
      </div>
    </template>
    <div v-if="theme != 'circle'" class="loading_inner">
      <div
        class="api_loading"
        :class="{ api_loading_light: theme == 'light'}"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    theme: {
      type: String,
      default: 'dark'
    }
  },
  data() {
    return {}
  },
  methods: {}
}
</script>




// WEBPACK FOOTER //
// src/components/LoadingService/APIloading.vue